import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import { API_HOST } from '../../constants/server.constant';
import ResourceService from '../../services/resource.service';
import CommonMessage from '../common/commonMessage';
import Invoice from './invoice';
import $ from 'jquery';
import ReactToolTip from 'react-tooltip';
export class MyInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            invTabActive: "inv_paid_tab",
            nextBillingDate: "",
            invoiceList: [],
            pagedInvoiceList: [],
            invoiceNoToggle: false,
            invoiceDateToggle: false,
            amountToggle: false,
            statusToggle: false,
            message: "",
            msgType: "",
            count: 50,
            indexCount: 0
        };

        this.toggleInvTab = this.toggleInvTab.bind(this);
        this.setSortable = this.setSortable.bind(this);
    }

    componentDidMount() {
        this.setNextBillingDate();
        this.getInvoiceDetails();
    }

    setNextBillingDate() {
        var now = new Date();
        if(now.getMonth() == 11) {
            var current = new Date(now.getFullYear() + 1, 0, 1);
            this.setState({
                nextBillingDate: this.formatDate(current)
            });
        } else {
            var current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
            this.setState({
                nextBillingDate: this.formatDate(current)
            });
        }
    }

    getInvoiceDetails() {
        this.setState({
            showLoader: true,
        });
        ResourceService.getInvoicesList().then(data => {
            this.setState({
                showLoader: false,
            });
            //console.log(data)
            if(data && data !== "") {

                for(let i = 0; i < data.length; i++) {
                    var d = new Date(data[i].invoicedate);
                    data[i].invoicedate = this.formatDate(d);
                }

                this.setState({
                    invoiceList: data,
                    invoiceDateToggle: false
                }, function () {
                    this.sortByInvoiceDate(this.state.invoiceList);
                });
            } else {
                this.setState({
                    invoiceList: [],
                    invoiceDateToggle: false
                });
            }
            $('.sort_icon').removeClass('active');
            $('#inv_date_span').addClass('active');
            //$('#inv_date_span').toggleClass('toggle_sort');
        }).catch(err => {
            console.log(err);
            this.setState({
                showLoader: false,
                message: "Error occured while fetching invoice details",
                msgType: "error"
            });
        });
    }

    formatDate(current) {
        var dd = current.getDate();
        var mm = current.getMonth() + 1;
        var yyyy = current.getFullYear();
        if(dd < 10) {
            dd = '0' + dd;
        }

        if(mm < 10) {
            mm = '0' + mm;
        }
        current = mm + '-' + dd + '-' + yyyy;
        return current;
    }

    toggleInvTab(tab) {
        this.setState({
            invTabActive: tab
        });
    }

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (param) => {

        let items = [...this.state.invoiceList];
        if(param[0] === "invoiceno") {
            if(this.state.invoiceNoToggle) {
                items.sort(function (a, b) {
                    if(a.invoiceno < b.invoiceno) { return -1; }
                    if(a.invoiceno > b.invoiceno) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.invoiceno < b.invoiceno) { return 1; }
                    if(a.invoiceno > b.invoiceno) { return -1; }
                    return 0;
                });

            }
            this.setState({
                // invoiceList: items,
                invoiceNoToggle: !this.state.invoiceNoToggle,
                invoiceDateToggle: false,
                amountToggle: false,
                statusToggle: false,
            });

        } else if(param[0] === "invoicedate") {
            this.sortByInvoiceDate(items);
        } else if(param[0] === "totalamount") {
            if(this.state.amountToggle) {
                items.sort(function (a, b) {
                    if(a.totalamount < b.totalamount) { return -1; }
                    if(a.totalamount > b.totalamount) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.totalamount < b.totalamount) { return 1; }
                    if(a.totalamount > b.totalamount) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //invoiceList: items,
                invoiceNoToggle: false,
                invoiceDateToggle: false,
                amountToggle: !this.state.amountToggle,
                statusToggle: false,
            });
        } else if(param[0] === "status") {
            if(this.state.statusToggle) {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return -1; }
                    if(a.status > b.status) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.status < b.status) { return 1; }
                    if(a.status > b.status) { return -1; }
                    return 0;
                });

            }
            this.setState({
                //invoiceList: items,
                invoiceNoToggle: false,
                invoiceDateToggle: false,
                amountToggle: false,
                statusToggle: !this.state.statusToggle,
            });
        }

        let pagedInvoiceList = [...items];
        if(items.length > 0) pagedInvoiceList = pagedInvoiceList.slice(0, this.state.count);
        this.setState({
            invoiceList: items,
            pagedInvoiceList: pagedInvoiceList,
            indexCount: 0
        });
    };

    sortByInvoiceDate(items) {
        if(this.state.invoiceDateToggle) {
            items.sort(function (a, b) {
                if(a.invoicedate < b.invoicedate) { return -1; }
                if(a.invoicedate > b.invoicedate) { return 1; }
                return 0;
            });
        }
        else {
            items.sort(function (a, b) {
                if(a.invoicedate < b.invoicedate) { return 1; }
                if(a.invoicedate > b.invoicedate) { return -1; }
                return 0;
            });
        }
        let pagedInvoiceList = [...items];
        if(items.length > 0) pagedInvoiceList = pagedInvoiceList.slice(0, this.state.count);
        this.setState({
            invoiceList: items,
            invoiceNoToggle: false,
            invoiceDateToggle: !this.state.invoiceDateToggle,
            amountToggle: false,
            statusToggle: false,
            pagedInvoiceList: pagedInvoiceList
        });
    }

    logout() {
        let userId = localStorage.getItem("userId");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = API_HOST + "/login/logout?userId=" + userId;
    }

    handleNextClick = (event) => {
        let invoiceList = [...this.state.invoiceList];
        let indexCount = this.state.indexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > invoiceList.length) endCount = invoiceList.length;
        this.setState({
            indexCount: indexCount,
            pagedInvoiceList: invoiceList.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let invoiceList = [...this.state.invoiceList];
        let indexCount = this.state.indexCount - this.state.count;
        this.setState({
            indexCount: this.state.indexCount - this.state.count,
            pagedInvoiceList: invoiceList.slice(indexCount, this.state.indexCount)
        });
        event.preventDefault();
    };

    render() {
        var role = localStorage.getItem("roleId");
        if(role == 1) {
            this.logout(); //if subuser tries to access just logout
            return null;
        }
        return (

            <section className="accountModule_wrapper billing_invoice_sec">
                {/* <div className="accModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>My Invoices</h2>
                            <p className="head_info">View the detailed invoices for your IDrive Compute account</p>
                        </div>
                    </div> */}
                <div className="field_sec_wrap clearfix no-tabs">
                    {/* <div className="bilHistory_tab_wrap">
                            <div className="custom_tabs_wrap">
                                <ul>
                                    <li className={"inv_unpaid_tab "+(this.state.invTabActive === "inv_paid_tab" ? "active " : "")} onClick={()=>this.toggleInvTab('inv_paid_tab')}>Paid <span className="notify_wrap">5</span></li>
                                    <li className={"inv_unpaid_tab "+(this.state.invTabActive === "inv_unpaid_tab" ? "active " : "")} onClick={()=>this.toggleInvTab('inv_unpaid_tab')}>Unpaid <span className="notify_wrap">0</span></li>
                                    <li className={"inv_cancel_tab "+(this.state.invTabActive === "inv_cancel_tab" ? "active " : "")} onClick={()=>this.toggleInvTab('inv_cancel_tab')}>Cancelled <span className="notify_wrap">2</span></li>
                                    <li className={"inv_refund_tab "+(this.state.invTabActive === "inv_refund_tab" ? "active " : "")} onClick={()=>this.toggleInvTab('inv_refund_tab')}>Refunded <span className="notify_wrap">1</span></li>
                                </ul>
                            </div>
                        </div> */}
                    <div className="section_table_wrap">
                        <div className="section_table_lhs">
                            <div className="section_head_wrap">
                                <div className="section_head_lhs">
                                    <h2>Invoice Details</h2>
                                </div>
                                {/* <div className="section_head_rhs">
                                        <div className="cta_wrap">
                                            <a href="accounts-creditCard_update.html"><div className="rhs_icons creditCardChange"><span className="svg_wrap"></span>Change credit card</div></a>
                                            <div className="rhs_icons">
                                                <span className="svg_wrap">
                                                    <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                        <g>
                                                            <g>
                                                                <path fill="#378EC3" d="M432.4,109.4H79.6C58.9,109.4,42,126.3,42,147v218c0,20.7,16.9,37.6,37.6,37.6h352.8    c20.7,0,37.6-16.9,37.6-37.6V147C470,126.3,453.1,109.4,432.4,109.4z M427.5,134.5l-5,4.2L270.9,264.8c-8.6,7.2-21.2,7.2-29.8,0    L89.5,138.6l-5-4.2H427.5z M67.1,152.6l123.5,102.8L67.1,337.5V152.6z M432.4,377.5H79.6c-6.1,0-11.1-4.3-12.3-10l143.3-95.4    l14.4,12c9,7.5,20,11.2,31,11.2c11,0,22-3.7,31-11.2l14.4-12l143.3,95.4C443.5,373.2,438.4,377.5,432.4,377.5z M444.9,337.5    l-123.5-82.2l123.5-102.8V337.5z"></path>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </span>Print
                                            </div>
                                        </div>
                                    </div> */}
                            </div>
                            <div className="tabular_data_wrap paid_table">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["invoiceno"]); } }>
                                                <div className="header_sort_wrap" >Invoice<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col2" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["invoicedate"]); } }>
                                                <div className="header_sort_wrap">Invoice Date<span className="sort_icon" id="inv_date_span"></span></div>
                                            </div>
                                            <div className="col col4" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["totalamount"]); } }>
                                                <div className="header_sort_wrap">Total<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col3" onClick={ (event) => { this.headerSortClick(event); this.setSortable(["status"]); } }>
                                                <div className="header_sort_wrap">Status<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col5">
                                                <div className="header_sort_wrap">View</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul> { this.state.invoiceList.length === 0 ?
                                        <li class="tr table_data_empty">
                                            <div class="outer_empty_wrap">
                                                <div class="inner_empty_wrap">
                                                    <div class="svg_wrap empty_icon billing_instance_empty"></div>
                                                    <p class="empty_title">No invoice details found</p>
                                                </div>
                                            </div>
                                        </li>
                                        : this.state.pagedInvoiceList.map(inv => (
                                            <li className="tr" key={ inv.id }>
                                                <div className="col col1" id="inv_overflow"><span data-tip={ inv.invoiceno }>{ inv.invoiceno }</span></div>
                                                { $("#inv_overflow").prop('scrollWidth') > $("#inv_overflow").prop('offsetWidth') ? <ReactToolTip effect="solid" place="top"></ReactToolTip> : null }
                                                <div className="col col2">{ inv.invoicedate }</div>
                                                <div className="col col3">${ inv.totalamount }</div>
                                                <div className="col col4">{ inv.status }</div>
                                                <div className="col col5"><Link to={ { pathname: "/invoice/" + inv.id } } target={ "_blank" }>Invoice</Link></div>
                                            </li>
                                        )) }
                                    </ul>
                                    <Route path="/invoice/:invoiceId" component={ Invoice }></Route>
                                </div>
                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.invoiceList.length > this.state.count ? '' : 'none' } }>
                                    <div className="Page_navigation">
                                        <ul className="pagination_ul">
                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                    <span aria-hidden="true">«</span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            </li>
                                            <li className="page-item">
                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.invoiceList.length ? this.state.invoiceList.length : (this.state.indexCount + this.state.count) }
                                                </a>
                                            </li>
                                            <li className={ this.state.indexCount + this.state.count > this.state.invoiceList.length - 1 ? "page-item disabled" : "page-item" }>
                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                    <span aria-hidden="true">»</span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <div className="tabular_data_wrap unpaid_table">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1">
                                                <div className="header_sort_wrap">Invoice<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col2">
                                                <div className="header_sort_wrap">Invoice Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col3">
                                                <div className="header_sort_wrap">Due Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col4">
                                                <div className="header_sort_wrap">Total<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col5">
                                                <div className="header_sort_wrap">View<span className="sort_icon"></span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul>
                                        <li className="tr data_empty">
                                            <div className="col col1">No invoices found!</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tabular_data_wrap cancel_table">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1">
                                                <div className="header_sort_wrap">Invoice<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col2">
                                                <div className="header_sort_wrap">Invoice Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col3">
                                                <div className="header_sort_wrap">Due Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col4">
                                                <div className="header_sort_wrap">Total<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col5">
                                                <div className="header_sort_wrap">View<span className="sort_icon"></span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul>
                                        <li className="tr">
                                            <div className="col col1">2769193</div>
                                            <div className="col col2">2020/08/07</div>
                                            <div className="col col3">2020/08/07</div>
                                            <div className="col col4">$10.00 </div>
                                            <div className="col col5"><a href="invoice.html">Invoice</a></div>
                                        </li>
                                        <li className="tr">
                                            <div className="col col1">2769193</div>
                                            <div className="col col2">2020/08/07</div>
                                            <div className="col col3">2020/08/07</div>
                                            <div className="col col4">$10.00 </div>
                                            <div className="col col5"><a href="invoice.html">Invoice</a></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tabular_data_wrap refund_table">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1">
                                                <div className="header_sort_wrap">Invoice<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col2">
                                                <div className="header_sort_wrap">Invoice Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col3">
                                                <div className="header_sort_wrap">Due Date<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col4">
                                                <div className="header_sort_wrap">Total<span className="sort_icon"></span></div>
                                            </div>
                                            <div className="col col5">
                                                <div className="header_sort_wrap">View<span className="sort_icon"></span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul>
                                        <li className="tr">
                                            <div className="col col1">2769193</div>
                                            <div className="col col2">2020/08/07</div>
                                            <div className="col col3">2020/08/07</div>
                                            <div className="col col4">$10.00</div>
                                            <div className="col col5"><a href="invoice.html">Invoice</a></div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="section_table_rhs" style={ { display: "none" } } >
                            <div className="unit_summary_rhs">
                                <div className="head_block">Billing Cycle Details</div>
                                <div className="summary_list">
                                    <ul>
                                        <li className="summary_instance_cost">
                                            <div className="summary_info">Next billing date:</div>
                                            <h4>{ this.state.nextBillingDate }</h4>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } handler={ () => this.setState({ message: "", msgType: '' }) } />
            </section >

        );
    }
}

export default MyInvoices;
